import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { PARTNER_INFO } from "src/app/share/constants/partner.constants";
import { PartnerInfoListInterface } from "src/app/share/interface/partner.interface";
import { PartnerService } from "src/app/share/service/partner.service";

@Component({
	selector: "app-footer",
	templateUrl: "./footer.component.html",
	styleUrls: ["./footer.component.scss"],
})
export class FooterComponent implements OnInit {
	partnerCode: string = "ps";

	get partner() {
    return PARTNER_INFO[this.partnerCode] || null;
  }

	constructor(private router: Router, private partnerService: PartnerService) {
		this.partnerCode = this.partnerService.getPartnerCode();
	}

	ngOnInit(): void {}
}


// <!-- MG footer -->
// <div class="ftr" *ngIf="partnerCode.length && partnerCode == 'mg'">
// 	<div class="ftr__container">
// 		<!-- Logo -->
// 		<div class="ftr__column">
// 			<div class="ftr__custom__logo__mg">
// 				<img
// 					src="https://storage.googleapis.com/ps-asset/digi_rep/logo/mg_logo_box.png"
// 					alt="policystreet"
// 				/>
// 				<span>{{ "footer.copyrightMG" | translate }} </span>
// 			</div>
// 		</div>
// 		<!-- Contacts -->
// 		<div class="ftr__column">
// 			<div>
// 				<img
// 					class="ftr__icon"
// 					src="./assets/icons/footer/whatsapp-fill.png"
// 					alt=""
// 				/>
// 				<span>+6018-351 2322 (WA message only) </span>
// 			</div>

// 			<div>
// 				<img
// 					class="ftr__icon"
// 					src="./assets/icons/footer/email-fill.png"
// 					alt=""
// 				/>
// 				<span>customerservice@policystreet.com </span>
// 			</div>
// 		</div>
// 	</div>
// 	<div class="ftr__bottom">
// 		<span>
// 			{{ "footer.desc" | translate }}
// 		</span>
// 	</div>
// </div>